import { createContext } from 'react';

export interface FactsheetOverlayContainerContextValue {
  container: HTMLElement | null;
  setContainer: (element: HTMLElement | null) => void;
}

export const FactsheetOverlayContainerContext =
  createContext<FactsheetOverlayContainerContextValue>({
    container: null,
    setContainer: () => {}
  });
